import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import styles from "./styles/link.css.js";
import withStyles from "components/with-styles";

const Link = ({ href = "#", children, onClick, disabled, color = "unset", classes, className, ...props }) => {
  const handleClick = e => {
    onClick && onClick(e);
    e.stopPropagation();
  };

  return disabled ? (
    children
  ) : (
    <RouterLink onClick={handleClick} to={href} className={cn(classes.link, className)} style={{ color }} {...props}>
      {children}
    </RouterLink>
  );
};

Link.propTypes = {
  /*
   * Clase adicional del componente
   */
  className: PropTypes.string,
  /*
   * Función que se llama al hacer click
   */
  onClick: PropTypes.func,
  /*
   * Url a la que enlaza el link
   */
  href: PropTypes.string,
  /*
   * Color de la url
   */
  color: PropTypes.string,
  /*
   * Evita que se genere el enlace
   */
  disabled: PropTypes.bool,
};

export default withStyles(styles)(Link);
